import "./Gauge.css";
function calculateGaugeValue(buy, sell) {
  const total = buy + sell;
  if (total === 0) return 0;
  return (buy - sell) / total;
}

function getGaugeLabel(value) {
  if (value <= -0.6) return "Strong Sell";
  if (value <= -0.2) return "Sell";
  if (value < 0.2) return "Neutral";
  if (value < 0.6) return "Buy";
  return "Strong Buy";
}

export default function Gauge({ buy, sell }) {
  const value = calculateGaugeValue(buy, sell);
  const label = getGaugeLabel(value);
  const angle = (value + 1) * 90;

  return (
    <div className="tv-gauge-wrapper">
      <svg
        viewBox="0 0 200 120"
        preserveAspectRatio="xMidYMid meet"
        className="tv-gauge-svg"
      >
        <path
          d="M20 100 A80 80 0 0 1 180 100"
          fill="none"
          stroke="#e5e7eb"
          strokeWidth="10"
        />

        <path
          d="M20 100 A80 80 0 0 1 100 20"
          fill="none"
          stroke="#ea3943"
          strokeWidth="10"
        />

        <path
          d="M100 20 A80 80 0 0 1 180 100"
          fill="none"
          stroke="#16c784"
          strokeWidth="10"
        />

        <line
          x1="100"
          y1="100"
          x2={100 + 70 * Math.cos((Math.PI * (180 - angle)) / 180)}
          y2={100 - 70 * Math.sin((Math.PI * (180 - angle)) / 180)}
          stroke="#111827"
          strokeWidth="3"
        />

        <circle cx="100" cy="100" r="4" fill="#111827" />
      </svg>

      <div className="tv-gauge-label">{label}</div>

      <div className="tv-gauge-counts">
        <span className="sell">Sell {sell}</span>
        <span className="buy">Buy {buy}</span>
      </div>
    </div>
  );
}
